module.exports = __webpack_public_path__ + "img/13-small.4f99760c.png";